import React, { useState, useRef } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import AdminService from '../../../../services/admin.service';
import toast from 'react-hot-toast';
import { CSVLink } from 'react-csv';
import download from "downloadjs";


export default function MockExam() {
    const [showUploadSheet, setShowUploadSheet] = useState(false);
    const [mockData, setMockData] = useState<any[]>([]);
    const csvLinkRef = useRef<any>(null);

    const handleUploadSheet = async (file: File | null) => {
        if (!file) {
            toast.error("Please select a CSV file before uploading.");
            return;
        }

        const formData = new FormData();
        formData.append('mockdata', file);

        try {
            const res = await AdminService.createMockExam(formData);

            if (res.status === 200) {
                const data = res.data;
                  download(res.data, "mock_data.csv", "text/csv");
                toast.success("Mock data uploaded successfully!");
                setShowUploadSheet(false);
            }
        } catch (err: any) {
            toast.error(err?.response?.data?.message || "Failed to upload mock data");
        }
    };

    return (
        <>
            <div className="d-flex justify-content-between text-primary align-items-center">
                <h5 className="mb-0">Mock Exam</h5>
                <Button size="sm" onClick={() => setShowUploadSheet(true)}>
                    Upload Sheet
                </Button>
            </div>

            <UploadSheetModal
                show={showUploadSheet}
                handleClose={() => setShowUploadSheet(false)}
                handleUploadSheet={handleUploadSheet}
            />

            {/* Hidden CSV download link triggered automatically */}
            {/* {mockData?.length > 0 && (
                <CSVLink
                    data={mockData}
                    filename="mock_data.csv"
                    ref={csvLinkRef}
                    className="d-none"
                    target="_blank"
                />
            )} */}
        </>
    );
}

type UploadModalProps = {
    show: boolean;
    handleClose: () => void;
    handleUploadSheet: (file: File | null) => void;
};

const UploadSheetModal = ({ show, handleClose, handleUploadSheet }: UploadModalProps) => (
    <Modal
        show={show}
        onHide={handleClose}
        animation={true}
        backdrop="static"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title>Upload Mock Sheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form.Group>
                <Form.Label className="fw-bold">Select File</Form.Label>
                <Form.Control
                    type="file"
                    accept=".csv"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        handleUploadSheet(e.target.files ? e.target.files[0] : null)
                    }
                />
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
);
